import * as React from 'react';
export default function TypingIndicator(){ return <div className='text-zinc-500 flex items-center'><span className='typing-dot'></span><span className='typing-dot'></span><span className='typing-dot'></span></div>; }
